import { gql } from "@apollo/client"

export const SUPERVISION_SESSION = gql`
  query SupervisionSession(
    $organization_id: ID!
    $pagination: TypePagination
    $staff_id: ID!
  ) {
    supervisionSessions(
      organization_id: $organization_id
      pagination: $pagination
      staff_id: $staff_id
    ) {
      data
      length
    }
  }
`

export const ENGAGEMENTS_STAFF = gql`
  query Engagements(
    $staff_id: ID!
    $organization_id: ID!
    $idTemplate: ID!
    $staff_selector_id: ID!
  ) {
    engagements: blocksSavedByIdStaffSelector(
      staff_id: $staff_id
      organization_id: $organization_id
      idTemplate: $idTemplate
      staff_selector_id: $staff_selector_id
      groupByIdStamp: true
    ) {
      data
      __typename
    }
  }
`

export const GET_SAVED_BLOCKS_BY_SELECTED_STAFF = gql`
  query TemplateSavedByStaffIdSelector(
    $staff_id: ID!
    $organization_id: ID!
    $idTemplate: ID!
    $staff_selector_id: ID!
  ) {
    TemplateSavedByStaffIdSelector(
      staff_id: $staff_id
      organization_id: $organization_id
      idTemplate: $idTemplate
      staff_selector_id: $staff_selector_id
    ) {
      data
    }
  }
`
